import { useMemo } from 'react'
import { calcShamble } from './ggShamble.js'
import { sampleTeams } from './ggSamplePlayers.js'

// G-Shamble — isolated sandbox. Best team score per hole; lowest total wins.
// calcShamble ported from GolfGamesScorecard. Ranks all sample teams.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }

export default function GShamble() {
  const rows = useMemo(() => calcShamble(sampleTeams()), [])
  const nm = (t) => t.map((p) => p.name.split(' ')[0]).join(' & ')

  return (
    <div className="card">
      <p className="text-sm text-gray-500 mb-3">Best drive, then each plays their own ball — lowest team score per hole counts.</p>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Pos', 'Team', 'Total'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>{rows.map((r, i) => (
          <tr key={i}><td style={cell}>{i + 1}</td><td style={cell}>{nm(r.team)}</td><td style={cell}><b>{r.total}</b></td></tr>
        ))}</tbody>
      </table>
    </div>
  )
}
